export enum EStatus
{
    success = 0,
    error = 1,
    default = 3,
    loadingTriggerTrue = 4,
    loadingTriggerFalse = 5,
}